// ==========================
// Version 12 - index.js (Thirdweb v5 on Polygon Amoy testnet, fixed client)
// ==========================
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './polyfills'; // <-- ensure Buffer/process/global exist in browser
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';

// Thirdweb v5
import { ThirdwebProvider } from 'thirdweb/react';
import { polygonAmoy } from 'thirdweb/chains';
import { thirdwebClient } from './thirdwebClient';

// CRA injects only REACT_APP_* vars
const THIRDWEB_CLIENT_ID = process.env.REACT_APP_THIRDWEB_CLIENT_ID;

if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.info(
    '[BWAK] Thirdweb Client ID present:',
    THIRDWEB_CLIENT_ID
      ? `yes (${THIRDWEB_CLIENT_ID.slice(0, 6)}…${THIRDWEB_CLIENT_ID.slice(-4)})`
      : 'NO'
  );
}

if (!THIRDWEB_CLIENT_ID) {
  // eslint-disable-next-line no-console
  console.error(
    '[BWAK] Thirdweb client ID is missing. Add REACT_APP_THIRDWEB_CLIENT_ID to .env.local (and restart npm start).'
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThirdwebProvider
      client={thirdwebClient}     // ✅ pass the client instance
      activeChain={polygonAmoy}   // ✅ your testnet
      autoConnect={false}         // ✅ disable auto-connect widgets
    >
      <AuthProvider>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </AuthProvider>
    </ThirdwebProvider>
  </React.StrictMode>
);

reportWebVitals();
// ==========================
// End Version 12 - index.js
// ==========================
